import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business パイプラインレイアウトルート。子ルート（一覧・詳細）のOutletラッパー
 * @graph-connects none
 */
export const Route = createFileRoute('/pipelines')({
  component: PipelinesLayout,
});

/** @graph-connects none */
function PipelinesLayout() {
  return <Outlet />;
}
